import { createSlice } from "@reduxjs/toolkit";

// Helper function to format dates as YYYY-MM-DD
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Function to get dynamic dates
const getDefaultDates = () => {
  const currentDate = new Date();
  const fromDate = new Date();
  fromDate.setDate(currentDate.getDate() - 30);
  return {
    fromDate: formatDate(fromDate),
    toDate: formatDate(currentDate),
  };
};

const initialState = (() => {
  const { fromDate, toDate } = getDefaultDates();
  return {
    filterOptions: {
      receving_date_from: fromDate,
      receving_date_to: toDate,
    },
    appliedFilters: {
      receving_date_from: fromDate,
      receving_date_to: toDate,
    },
    isFilterActive: false,
  };
})();

export const receivingDashboardFilterSlice = createSlice({
  name: "receivingFilter",
  initialState,
  reducers: {
    setFilterOption: (state, action) => {
      const { name, value } = action.payload;
      state.filterOptions[name] = value;
    },
    applyFilters: (state) => {
      state.appliedFilters = { ...state.filterOptions };
      state.isFilterActive = true;
    },
    clearFilter: (state) => {
      const { fromDate, toDate } = getDefaultDates();
      state.filterOptions = {
        receving_date_from: fromDate,
        receving_date_to: toDate,
      };
      state.appliedFilters = {
        receving_date_from: fromDate,
        receving_date_to: toDate,
      };
      state.isFilterActive = false;
    },
  },
});

export const { setFilterOption, applyFilters, clearFilter } =
  receivingDashboardFilterSlice.actions;
export const selectFilterOptions = (state) =>
  state.receivingFilter.filterOptions;
export const selectAppliedFilters = (state) =>
  state.receivingFilter.appliedFilters;
export default receivingDashboardFilterSlice.reducer;
